<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (fanSpeedSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Fan Speed:</label>
            <select class="configurationInputField" #fanSpeedInput
              [class.invalidConfigurationSelection]="isInvalidSelection(fanSpeedSelection.Name)"
              (change)="selectionChanged(fanSpeedSelection, fanSpeedInput.value)"
              [value]="fanSpeedSelection.Value.toString()">
              @for (allowable of fanSpeedSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="fanSpeedSelection.Value && fanSpeedSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (espSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">ESP:</label>
            <input type="number" class="configurationRatingTextInput" #espInput [value]="espSelection.Value"
              step="0.01" (change)="selectionChanged(espSelection, espInput.value || '0')">
            <label class="configurationRatingUnitLabel">{{ getPressureMeasurementUnits() }}</label>
          </span>
        }
        @if (altitudeSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Altitude:</label>
            <input type="number" class="configurationRatingTextInput" #altitudeInput
              [value]="altitudeSelection.Value"
              (change)="selectionChanged(altitudeSelection, altitudeInput.value)">
            <label class="configurationRatingUnitLabel">{{ getDistanceMeasurementUnits() }}</label>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (inputTypeSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Input Type:</label>
            <select class="configurationInputField" #inputTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(inputTypeSelection.Name)"
              (change)="inputTypeChanged(inputTypeInput.value)" [value]="inputTypeSelection.Value">
              @for (allowable of inputTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                            [selected]="inputTypeSelection.Value != undefined && inputTypeSelection.Value != null
                                     && inputTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (ecoAirflowSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Eco Motor Airflow:</label>
            <input type="number" class="configurationRatingTextInput" #ecoAirflowInput
              [value]="ecoAirflowSelection.Value"
              (change)="selectionChanged(ecoAirflowSelection, ecoAirflowInput.value || '0')">
            <label class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits() }}</label>
          </span>
        }
        <span class="configurationInput">
        </span>
      </div>
      <app-heating-only-performance-input [engineKey]="engineKey()" [selectionEntities]="selectionEntities()" [isMetric]="isMetric"
        (valueChanged)="performanceValueChanged()">
      </app-heating-only-performance-input>
      @if (ratingResponseError) {
        <div class="ratingError">
          {{ ratingResponseError }}
        </div>
      }
    </div>
  }
</div>
